import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n);

const messages = {
    "en": {
        header: {
            home: 'HOME',
            register: 'JOIN',
            check_status: 'Check Status',
        },
        footer: {
            allrights: '© Airport Authority Hong Kong. All Rights Reserved.',
            privacy: 'Privacy Policy',
            tnc: 'Terms of Use',
        },

        home: {
            hkaa_link: 'https://www.hongkongairport.com/en/',

            text_1: 'LANDSIDE STAFF CAFETERIA',
            text_2: 'EXCLUSIVELY FOR<br> AIRPORT STAFF',
            text_3: 'Register with your Airport Staff Octopus Card and able to access Landside Staff Cafeteria',
            register: 'Join Now',
            check_status: 'Check my record',

            map_and_location: 'MAP & LOCATION',
            map_and_location_content: 'Address:<br> Landside Staff Cafeteria,10/F,<br> Airport Community Building, 13 Cheong Tat Road,<br> Hong Kong International Airport, Lantau, Hong Kong ',
        },

        register: {
            title: 'Registration of Landside Staff Cafeteria',

            tnc: 'Terms and Conditions',
            agree_tnc: 'I agree to the terms and conditions',
            require_tnc: 'Please agree to terms and conditions',

            step_2: 'Registration of Landside Staff Cafeteria',
            surname: 'Surname on Airport Staff Octopus Card (English)',
            given_name: 'Given Name on Airport Staff Octopus Card (English)',
            octopus_no: 'Airport Staff Octopus Card Number with 8 - 10 digits',
            octopus_no_hint: '(including the digit in bracket)',
            enter_required_field: 'Please enter this required field',
            incorrect_octopus_no: 'Please input Airport Staff Number Octopus Card with 8 - 10 digits',
            only_input_english_characters: 'Please only enter english characters',

            step_3: 'Registration of Landside Staff Cafeteria',
            company: 'Company',
            other_company_name: 'Company Name',
            select_company: 'Please select your company',
            cannot_find_company: 'Could not find your company?',
            enter_company_name: 'Please enter your company name',

            step_4: 'Upload Identifications',
            octopus_front: 'Airport Staff Octopus Card (Front)',
            octopus_back: 'Airport Staff Octopus Card (Back)',
            staff_card_front: 'Company Staff Card (Front)',
            staff_card_back: 'Company Staff Card (Back)',

            ocr_fail_msg: 'Octopus Validation Failed. Please Try Again',

            registration_complete: 'Registration of Landside Staff Cafeteria',
            registration_complete_details: 'Your registration has been approved. You will be able to access Landside Staff Cafeteria with your registered Airport Octopus Card after 30 minutes.',

            registration_pending: 'Registration Pending',
            registration_pending_details: 'Your registration has been submitted and being reviewed. Please come back and check your registration status after approximately 7 days',

            hkiarace_upsell: 'Want to become a HKIARaCE Registered Staff too?',
            hkiarace_btn: 'How to register?',
            hkiarace_btn_subtitle: 'Join now to enjoy more privileges',
            aca: 'Stay Tuned!',
            aca_subtitle: 'Download the HKG Community App now to get latest discounts.',
            appstore_link: 'https://apps.apple.com/hk/app/hkg-community/id1495936143?l=en',
        },

        check_status: {
            title: 'Check Registration Status',

            octopus_no: 'Octopus Card No.',
            name: 'Name',
            status: 'Status',
            validated_at: 'Approved At',
            rejected_at: 'Rejected At',
            suspended_at: 'Suspended At',

            pending: 'Pending',
            pending_msg: 'Your registration has been submitted and being reviewed. Please come back and check your registration status after 1-2 working days',
            approved: 'Approved',
            approved_msg: 'Your registration has been approved. You will be able to access Landside Staff Cafeteria with your registered Airport Octopus Card at 12:00nn on 1 December 2022.',
            rejected: 'Rejected',
            rejected_msg: 'Your registration is not successful. Please try register again or contact us',
            suspended: 'Suspended',
            suspended_msg: 'Your account has been suspended. Please try register again or contact us',
        },

        id_type: {
            AIRPORT_OCTOPUS: 'Airport Octopus Card',
            PERSONAL_OCTOPUS_AND_STAFF_CARD: 'Personal Octopus Card + Company Staff Card',
        },
        error_messages: {
            octopus_not_registered: 'Octopus Card Not Registered.',
            octopus_already_registered: 'Octopus Card Already Registered Under Another Name',
        },
        back: 'Back',
        next: 'Next',
        submit: 'Submit',
        resubmit: 'Re-Submit',
        upload: 'Upload',
        close: 'Close',
    },
    "zh": {
        header: {
            home: '主頁',
            register: '登記',
            check_status: '查詢登記狀況',
        },
        footer: {
            allrights: '© 香港機場管理局版權所有',
            privacy: '私隱政策',
            tnc: '條款及細則',
        },

        home: {
            hkaa_link: 'https://www.hongkongairport.com/tc/',

            text_1: '機場員工餐廳',
            text_2: '專屬機場員工使用',
            text_3: '請即登記機場員工八達通進入機場員工餐廳。',
            register: '立即登記',
            check_status: '查詢登記狀況',

            map_and_location: '地圖和位置',
            map_and_location_content: '機場員工餐廳<br>香港大嶼山香港國際機場<br>暢達路13號, 機場員工綜合大樓10樓',
        },

        register: {
            title: '機場員工餐廳登記',

            tnc: '條款及細則',
            agree_tnc: '我已閲讀並同意條款及細則',
            require_tnc: '請同意',

            step_2: '機場員工餐廳登記',
            surname: '機場員工八達通卡的英文姓氏',
            given_name: '機場員工八達通卡的英文名字',
            octopus_no: '8 - 10位機場員工八達通卡號',
            octopus_no_hint: '（包括括號內的數字）',
            enter_required_field: '請輸入此必填項',
            incorrect_octopus_no: '請輸入8 - 10位機場員工八達通卡號',
            only_input_english_characters: '請只輸入英文字母',
            only_input_digits: '請只輸入8位或9位八達通卡號碼',

            step_3: '機場員工餐廳登記',
            company: '公司',
            other_company_name: '公司名稱',
            select_company: '請選擇公司',
            cannot_find_company: '找不到您的公司？',
            enter_company_name: '請輸入公司名稱',

            step_4: '上傳身份認證資料',
            octopus_front: '機場員工八達通卡 (正面)',
            octopus_back: '機場員工八達通卡 (背面)',
            staff_card_front: '公司員工證 (正面)',
            staff_card_back: '公司員工證 (背面)',

            ocr_fail_msg: '系統未能辨認機場八達通，請重新拍攝。',

            registration_complete: '機場員工餐廳登記',
            registration_complete_details: '你已成功登記，可於30分鐘後使用已註冊的機場八達通卡進入機場員工餐廳',

            registration_pending: '等待確認',
            registration_pending_details: '我們將手動驗證您的身份。請於大約七天後查詢登記狀況。',

            hkiarace_upsell: '想成為機場同業綜藝社登記員工? ',
            hkiarace_btn: '如何登記?',
            hkiarace_btn_subtitle: '現在登記 可享更多優惠',
            aca: '敬請留意',
            aca_subtitle: '立即下載 HKG Community App 以獲得最新優惠',
            appstore_link: 'https://apps.apple.com/hk/app/hkg-community/id1495936143',
        },

        check_status: {
            title: '查詢登記狀況',

            octopus_no: '八達通卡號碼',
            name: '八達通卡上的英文全名',
            status: '狀態',
            validated_at: '認證於',
            rejected_at: '拒絕申請於',
            suspended_at: '停用於',

            pending: '等待審批',
            pending_msg: '我們將手動驗證您的身份。請於一至兩個工作天後查詢登記狀況。',
            approved: '已認證',
            approved_msg: '你已成功登記，可於2022年12月1日下午12時使用已註冊的機場八達通卡進入機場員工餐廳。',
            rejected: '申請已被拒絕',
            rejected_msg: '您的註冊不成功。請嘗試重新註冊或我們聯絡',
            suspended: '已停用',
            suspended_msg: '您的戶口已被暫停。請重新註冊或我們聯絡',
        },

        id_type: {
            AIRPORT_OCTOPUS: '機場八達通卡',
            PERSONAL_OCTOPUS_AND_STAFF_CARD: '個人八達通卡及公司員工證',
        },
        error_messages: {
            octopus_not_registered: '八達通卡未登記',
            octopus_already_registered: '八達通卡已以其他名義登記',
        },
        back: '上一步',
        next: '下一步',
        submit: '遞交',
        resubmit: '重新提交',
        upload: '上傳',
        close: '關閉',
    },
};

const i18n = new VueI18n({
    locale: 'en',
    messages,
});

export default i18n;
